import React, { createContext, ReactNode, useContext } from 'react';

const diskUrlContext = createContext({
    showOpenUrlButton: false,
});

const MarkerDiskUrlProvider = diskUrlContext.Provider;

const markerDiskUrlContextValue = { showOpenUrlButton: true };

export const MarkerDiskUrlShowButtonProvider = ({ children }: { children: ReactNode }) => (
    <MarkerDiskUrlProvider value={markerDiskUrlContextValue}>{children}</MarkerDiskUrlProvider>
);

export const useDiskUrlContext = () => useContext(diskUrlContext);
